/** @format */

import {ReactNode} from 'react';

import {Box} from '@mui/material';
import {makeStyles, createStyles} from '@mui/styles';

import GreenRadio from 'components/radios/GreenRadio';

interface RadioRowProps {
  selected: boolean;
  mt?: number;
  onSelect: () => void;
  children?: ReactNode;
}

const useStyles = makeStyles(() =>
  createStyles({
    childrenNew: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexGrow: 1,
    },
  }),
);

const RadioRow = (props: RadioRowProps) => {
  const classes = useStyles();

  return (
    <Box
      alignItems='center'
      display='flex'
      flexGrow={1}
      flexWrap='wrap'
      justifyContent='flex-start'
      mt={props.mt}
    >
      <Box display='flex' alignItems='center' onClick={props.onSelect}>
        <GreenRadio checked={props.selected} variant='SQUARE' />
      </Box>
      <Box className={classes.childrenNew}>{props.children}</Box>
    </Box>
  );
};

export default RadioRow;
